// Setup the click actions on any addon elements
import 'mdn-polyfills/Element.prototype.matches';

document.addEventListener('DOMContentLoaded', function(){
    try {
        initClickableElements();
    } catch (error) {
        console.error(error);
    }
});
$(document).on('show.bs.modal', function(){
    initClickableElements();
});

let initClickableElements = function() {
    const addons = document.querySelectorAll(".clickable")
    _.each(addons, function(addon) {
        addon.addEventListener('click', function(event) {
            let clickable = getClosest(event.target, '.clickable');
            if(clickable) {
                let focus_indicator = childMatch(clickable, '[data-focusid]');
                if(focus_indicator.length) {
                    let focusid = focus_indicator[0].getAttribute('data-focusid');
                    document.getElementById(focusid).focus();
                } else {
                    console.error('data-focusid not found.');
                }
            }
        });
    });
};

let getClosest = function (elem, selector) {
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;
};

let childMatch = function (elem, selector) {
	return Array.prototype.filter.call(elem.children, function (child) {
		return child.matches(selector);
	});
};

